import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

import Button from '@components/common/Button';
import ModalWrapper from '@components/common/Modal/ModalWrapper';

import { Size, Variant } from '@constants/common/ui.constants';

import { BackModalProps } from '@app-types/common/modal.types';

import useStyles from './styles.module';

const BackModal: FC<BackModalProps> = ({ onCancel, onConfirm }) => {
  const { classes } = useStyles();

  return (
    <ModalWrapper title="Back" onClose={onCancel}>
      <div className={classes.box}>
        <Typography variant="body2">
          If you exit, the data entered on the form will be lost
        </Typography>
        <div className={classes.btns}>
          <Button
            size={Size.Small}
            fullWidth
            variant={Variant.Contained}
            onClick={onCancel}
            className={classes.btn}
          >
            Cancel
          </Button>
          <Button size={Size.Small} fullWidth onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default BackModal;
